module.exports = __webpack_public_path__ + "img/load.e0a06106.png";